import {useEffect} from 'react';
import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import * as loaderNames from '../../../consts/loader/loaderNames';
import iotDeviceSettingsService from '../../../services/iotDevice/iotDeviceSettingsService';
import productService from '../../../services/product/productService';
import yapConnectionService from '../../../services/yap/yapConnectionService';
import {hideLoader} from '../../../state/ducks/global';
import {makeSelectIotDeviceMergedWithConsumerProduct} from '../../../state/selectors/consumer';
import {
    selectIsScpCheckInProgress,
    selectIsSkipRegistration,
    selectIsStartAutoSync,
} from '../../../state/selectors/global';
import {selectIsDeviceReady, selectIsFirmwareInProgress} from '../../../state/selectors/iotDevice';
import {
    makeSelectIsYapActivationInProgress,
    makeSelectIsYapFirmwareInProgress,
    makeSelectIsYapHolderInfoReceived,
    makeSelectIsYapUpdateSettingsInProgress,
} from '../../../state/selectors/yapEncrypted';
import {dispatch} from '../../../state/store';

const mapStateToProps = createStructuredSelector({
    iotProduct: makeSelectIotDeviceMergedWithConsumerProduct(),
    isDeviceReady: selectIsDeviceReady,
    isYapHolderInfoReceived: makeSelectIsYapHolderInfoReceived(),
    isStartAutoSync: selectIsStartAutoSync,
    isScpCheckInProgress: selectIsScpCheckInProgress,
    isFirmwareInProgress: selectIsFirmwareInProgress,
    isYapActivationInProgress: makeSelectIsYapActivationInProgress(),
    isYapUpdateSettingsInProgress: makeSelectIsYapUpdateSettingsInProgress(),
    isYapFirmwareInProgress: makeSelectIsYapFirmwareInProgress(),
    isSkipRegistration: selectIsSkipRegistration,
});

const DeviceHolderConnectionChecker = ({
    iotProduct,
    isDeviceReady,
    isYapHolderInfoReceived,
    isStartAutoSync,
    isScpCheckInProgress,
    isFirmwareInProgress,
    isYapActivationInProgress,
    isYapUpdateSettingsInProgress,
    isYapFirmwareInProgress,
    isSkipRegistration,
}) => {
    const {device, holder} = iotProduct || {};
    const {status: deviceStatus, isHolderConnected} = device || {};
    const {status: holderStatus, deviceSerialNumber: holderSerialNumber} = holder || {};
    const isCurrentDeviceRegistered = productService.getIsRegistered(deviceStatus);
    const isCurrentHolderRegistered = productService.getIsRegistered(holderStatus);
    const isRegAllowsStart = isCurrentHolderRegistered || isSkipRegistration;
    const isCurrentDeviceRegisteredFailed = productService.getIsRegisterFailed(deviceStatus);
    const isCurrentHolderRegisteredFailed = productService.getIsRegisterFailed(holderStatus);
    const isHolderInSBLMode = iotDeviceSettingsService.isHolderInSBLMode(iotProduct);
    const isStartHolderSync =
        holderSerialNumber &&
        isRegAllowsStart &&
        isDeviceReady &&
        isHolderConnected &&
        !isYapHolderInfoReceived &&
        isStartAutoSync &&
        !isScpCheckInProgress &&
        !isHolderInSBLMode &&
        !isFirmwareInProgress &&
        !isYapActivationInProgress &&
        !isYapUpdateSettingsInProgress &&
        !isYapFirmwareInProgress;

    useEffect(() => {
        if (isStartHolderSync) {
            yapConnectionService.initSynchronizeFlow(true);
        }
    }, [isStartHolderSync]);

    useEffect(() => {
        if (
            (isCurrentDeviceRegistered && isCurrentHolderRegistered) ||
            (isCurrentDeviceRegistered && isCurrentHolderRegisteredFailed) ||
            (isCurrentDeviceRegisteredFailed && isCurrentHolderRegistered) ||
            (isCurrentDeviceRegisteredFailed && isCurrentHolderRegisteredFailed)
        ) {
            dispatch(hideLoader(loaderNames.REGISTERING_LOADER));
        }
    }, [isYapHolderInfoReceived, isCurrentHolderRegisteredFailed, isCurrentHolderRegistered]);

    return null;
};

export default connect(mapStateToProps)(DeviceHolderConnectionChecker);
